<template>
  <auth-shell welcome="Hoş Geldiniz," title="Hesabınıza Giriş Yapın">
    <div class="vy-card">
      <div v-if="errorMessage" class="vy-error" role="alert">
        <span class="material-symbols-outlined">error</span>
        <span v-text="errorMessage"></span>
      </div>

      <!-- Mobil imza ile giriş -->
      <div v-if="fingerprint" class="lg-sign">
        <div class="lg-sign-header">
          <button type="button" class="lg-back" :disabled="waitingMobile" aria-label="Geri" @click="fingerprint = null">
            <span class="material-symbols-outlined">arrow_back</span>
          </button>
          <h2 class="lg-sign-title">Mobil İmza ile Giriş</h2>
        </div>

        <p class="lg-sign-text">
          İzOnay uygulamasında <b>{{ loginData.AccountCode }}</b> hesap kodu ile oturum açmayı kabul ediyorum.
        </p>

        <div class="lg-info">
          <div class="lg-info-row">
            <span class="lg-info-label">E-posta</span>
            <span class="lg-info-value">{{ fingerprint.Email }}</span>
          </div>
          <div class="lg-info-row">
            <span class="lg-info-label">GSM</span>
            <span class="lg-info-value">{{ fingerprint.GSM }}</span>
          </div>
          <div class="lg-info-row lg-info-row-top">
            <span class="lg-info-label">Parmak İzi</span>
            <span class="lg-info-value lg-fingerprint">{{ fingerprint.Fingerprint }}</span>
          </div>
        </div>

        <div v-if="timerShow" class="lg-waiting">
          <CountdownTimer :counter="timer"></CountdownTimer>
          <p class="lg-waiting-text"><Spinner></Spinner> Mobil imza onayı bekleniyor...</p>
        </div>

        <div class="vy-actions vy-actions-row">
          <button type="button" class="btn vy-btn vy-btn-outline" :disabled="waitingMobile" @click="fingerprint = null">Vazgeç</button>
          <button type="button" class="btn vy-btn vy-btn-navy" :disabled="waitingMobile" @click="mobileSign">Mobil İmzala</button>
        </div>
      </div>

      <!-- Giriş formu -->
      <!-- v-show: form DOM'da kalır; captcha resmi ve $refs.captcha mobil imza kartı açıkken de korunur -->
      <form v-show="!fingerprint" @submit.prevent="login()">
        <fieldset :disabled="loading" class="vy-fieldset">
          <div class="lg-account">
            <span class="lg-account-icon"><span class="material-symbols-outlined">person</span></span>
            <div class="lg-account-info">
              <div class="lg-account-code">{{ loginData.AccountCode }}</div>
              <div class="lg-account-email">{{ loginData.Email }}</div>
            </div>
            <a class="vy-link" href="#" @click.prevent="$router.push('/')">Hesap değiştir</a>
          </div>

          <label class="vy-label" for="password">Parola</label>
          <div class="vy-field">
            <span class="material-symbols-outlined vy-field-icon">lock</span>
            <input
              id="password"
              v-model="loginData.Password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="Parolanızı girin"
              autocomplete="current-password"
              required
            />
            <button type="button" class="vy-field-action" :aria-label="showPassword ? 'Parolayı gizle' : 'Parolayı göster'" @click="showPassword = !showPassword">
              <span class="material-symbols-outlined">{{ showPassword ? 'visibility_off' : 'visibility' }}</span>
            </button>
          </div>

          <div v-show="captcha && captcha.isCaptchaRequired">
            <label class="vy-label vy-label-spaced">Doğrulama Kodu</label>
            <div class="vy-field vy-field-captcha">
              <span
                class="vy-captcha"
                title="Doğrulama kodunu yenilemek için tıklayın"
                ref="captcha"
                @click="checkCaptchaRequirement()"
              ></span>
              <span class="material-symbols-outlined vy-field-icon">shield</span>
              <input
                v-model="loginData.Captcha"
                type="text"
                placeholder="Kodu girin"
                autocomplete="off"
                :required="captcha && captcha.isCaptchaRequired"
              />
            </div>
          </div>

          <div class="vy-actions">
            <button type="submit" class="btn vy-btn vy-btn-orange">Giriş</button>
            <button type="button" class="btn vy-btn vy-btn-navy" @click="getAgreement">
              <span class="material-symbols-outlined">fingerprint</span>
              Mobil İmza ile Giriş
            </button>
          </div>
        </fieldset>

        <div v-show="isExternalLoginAvailable" class="vy-external" id="external-logins">
          <div class="vy-divider"><span>veya şununla oturum açın</span></div>
          <LoginWithADFS v-if="isADFSLoginEnabled"></LoginWithADFS>
          <LoginWithMicrosoft v-else></LoginWithMicrosoft>
        </div>
      </form>
    </div>
  </auth-shell>
</template>
<script>
import axios from "axios";
import Spinner from '../components/Spinner.vue'
import LoginWithMicrosoft from '@/components/Login/LoginWithMicrosoft.vue'
import LoginWithADFS from '@/components/Login/LoginWithADFS.vue'
import CountdownTimer from "../components/CountdownTimer.vue";
import AuthShell from "../components/Voya/AuthShell.vue";
export default {
  mounted() {
    if (this.loginData.AccountCode && this.loginData.Email) {
      this.checkCaptchaRequirement();
    }
  },
  computed: {
        isADFSLoginEnabled(){
            return window.settings.authentication?.adfs?.enabled;
        },
        isAzureLoginEnabled(){
            return window.settings.authentication?.adfs?.enableAzure;
        },
        isExternalLoginAvailable()
        {
            if(!this.isOnPrem || this.isADFSLoginEnabled  || this.isAzureLoginEnabled)
                return true;

            return false;
        }
  },
  components: {
    AuthShell,
    Spinner,
    CountdownTimer,
    LoginWithMicrosoft,
    LoginWithADFS
  },
  data() {
    return {
      loading: false,
      showPassword: false,
      loginData: {},
      step: 0,
      captcha: null,
      errorMessage: null,
      fingerprint: null,
      timerShow: false,
      waitingMobile: false,
      timer: 60,
    };
  },
  beforeMount() {
    if(location.hash.includes('#')){
      var hash = location.hash.replace("#", "");
      var accountUser = hash.split("&");
      var emailArray = accountUser[1].split("?")
      var code = decodeURIComponent(accountUser[0]);
      var email = decodeURIComponent(emailArray[0]);
    }

    if (!accountUser) {
      this.$router.push("/");
    } else {
      if (!code || !email){
        this.$router.push("/");
      }
      else {
        this.loginData.AccountCode = code;
        this.loginData.Email = email;
      }
    }
  },
  methods: {
    imgLogoPath() {
      try {
        return window.settings.customization.imgLogo == null ? require("../assets/logo.png") : "../img/" + window.settings.customization.imgLogo;
      } catch (e) {
        return require("../assets/logo.png");
      }
    },
    mobileSign() {
        this.timerShow = true;
        this.waitingMobile = true;
        axios.post('token/SignMobile', {
            AccountCode: this.loginData.AccountCode,
            Email: this.loginData.Email,
            GSM: "5547789703",
            Agreement: this.fingerprint.Agreement,
            FingerPrintTempFileId: this.fingerprint.FingerPrintTempFileId,
            source: "Mobile"
        }, { silent: true }) // onay bekleme durumu kartta zaten gösteriliyor, sayfa yükleme katmanı çıkmaz
            .then(x => {
                console.log('MobileSign login result:', x);
                if (x.data.Success) {
                    window.localStorage.setItem('user', JSON.stringify(x.data.Data));
                    axios.defaults.headers.common['token'] = x.data.Data.Key;
                    this.$root.$data.login = x.data.Data
                    this.registerDeviceToken();
                    this.saveBaseUrl();
                    if(this.$route.query.redirect)
                      this.$router.push(this.$route.query.redirect);
                    else
                      this.$router.push("/index");
                } else {
                    this.timer = 2;
                    this.waitingMobile = false;
                    this.loading = false;
                    this.fingerprint = null;
                    this.loginData.Email = null;
                    this.loginData.GSM = null;
                    this.processingMessage = null;
                    this.timerShow = false;
                    this.showbutton = true
                    this.waitingMobile = false;
                    this.errorMessage = x.data.ErrorMessages
                }
            })
            .catch(x => {
                console.log('Mobile Oturum aç cevabı: ', x);
                this.waitingMobile = false;
                this.loading = false;
                this.loginData.Email = null;
                this.loginData.GSM = null;
                this.timer = 2;
                window.processErrorResponse(x, this);
            })

    },
    getAgreement() {
        this.loading = true;
        this.fingerprint = null;
        this.errorMessage = null;
        this.processingMessage = 'Parmakizi Hesaplanıyor..';
        return axios.post('token/Calculatefingerprint', {
            AccountCode: this.loginData.AccountCode,
            Email: this.loginData.Email,

        })
            .then(x => {
                this.loginData.accountCode = x.data.AccountCode;
                this.fingerprint = x.data;
                this.$forceUpdate();
            })
            .catch(x => {
                window.processErrorResponse(x, this);
                console.log('Oturum taahhütnamesi oluşturulamadı: ', x);
            }).then(() => {
                this.loading = false;
                this.processingMessage = null;
            });
    },
    checkCaptchaRequirement() {
      this.step = 1;
      this.loading = true;
      axios
        .post('/token/isCaptchaRequired', { Email: this.loginData.Email})
        .then(x => {
          this.captcha = x.data;
          this.loginData.Identifier = x.data?.identifier;
          this.$refs.captcha.style = `background-image: url('data:image/jpg;base64,${x.data.image}')`;
          this.loginData.Captcha = null;
          this.loading = false;
        })
        .catch(x => {
          this.step = 0;
          window.processErrorResponse(x, this);
          this.$refs.captcha.style =
            "background-color:red; background-image:none;";
          this.loginData.Identifier = null;
          this.loginData.Captcha = null;
          this.loading = false;
        });
    },
    async loginWithEmail() {
      const { data } = await axios.post("/token/post", {
        accountCode: this.loginData.AccountCode,
        email: this.loginData.Email,
        password: this.loginData.Password,
        identifier: this.loginData.Identifier,
        captcha: this.loginData.Captcha,
        source: "Mobile"
      });
      return data;
    },
    login() {
      this.errorMessage = null;
      this.loading = true;

      this.loginWithEmail()
        .then(x => {
          this.errorMessage = null;
          console.log("Gelen sonuç:", x);
          if (x.Success) {
            if (x.Data.SessionId) {
              this.$router.push({
                name: "/mfa",
                params: { loginData: x.Data },
                query: { redirect: this.$route.query.redirect }
              });
            } else {
              window.localStorage.setItem("user", JSON.stringify(x.Data));
              axios.defaults.headers.common["token"] = x.Data.Key;
              this.$root.$data.login = x.Data;

              this.$store.commit("setUser", x.Data.User);
              this.registerDeviceToken();
              this.saveBaseUrl();
              if(this.$route.query.redirect)
                this.$router.push(this.$route.query.redirect);
              else
                this.$router.push("/index");

              console.log(
                "Token geldi: ",
                axios.defaults.headers.common["token"]
              );
            }
          } else {
            this.errorMessage = x.ErrorMessages;
            this.checkCaptchaRequirement();
          }
          console.log("Token geldi: ", axios.defaults.headers.common["token"]);
        })
        .catch(e => {
          console.log("Error:", e);
          if (e.response === undefined) {
            this.errorMessage =
              "Erişim sağlanamadı. Lütfen internet bağlantınızı kontrol edin.";
          } else if (e.response.status == 400) {
            this.errorMessage =
              window.getModelStateString(e.response.data.ModelState) ||
              e.response.data.Message;
          } else {
            this.errorMessage =
              "Beklenmeyen bir hata oluştu. Lütfen bir süre sonra tekrar deneyin";
          }
          this.checkCaptchaRequirement();
        });
    }
  }
};
</script>
<style scoped>
/* Hesap özeti */
.lg-account {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding: 12px;
  border: 1px solid #DCE3F2;
  border-radius: 12px;
  background-color: #F1F7FF;
}

.lg-account-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #ffffff;
  color: #182F5E;
}

.lg-account-info {
  flex: 1 1 auto;
  min-width: 0;
}

.lg-account-code {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  font-size: 15px;
  line-height: 140%;
  color: #092154;
}

.lg-account-email {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: #808080;
}

/* Mobil imza ile giriş */
.lg-sign-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.lg-back {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
  color: #092154;
  font-size: 24px;
}

.lg-back:disabled {
  opacity: 0.4;
}

.lg-sign-title {
  margin: 0;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  color: #092154;
}

.lg-sign-text {
  margin: 0 0 16px 0;
  font-weight: 400;
  font-size: 13px;
  line-height: 150%;
  color: #333333;
}

.lg-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  box-sizing: border-box;
  min-height: 48px;
  padding: 10px 0;
  border-bottom: 1px solid #EFEFEF;
}

.lg-info-row-top {
  align-items: flex-start;
  border-bottom: none;
}

.lg-info-label {
  flex: 0 0 auto;
  font-weight: 500;
  font-size: 14px;
  color: #808080;
}

.lg-info-value {
  min-width: 0;
  font-weight: 400;
  font-size: 14px;
  text-align: right;
  color: #333333;
  word-break: break-word;
}

.lg-fingerprint {
  padding: 4px 10px;
  border-radius: 8px;
  background-color: #F1F7FF;
  font-weight: 600;
  letter-spacing: 1px;
  color: #092154;
}

.lg-waiting {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.lg-waiting-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 0;
  font-weight: 400;
  font-size: 13px;
  color: #097DFF;
}
</style>
